import * as React from "react";
import { Box, Alert, IconButton, Collapse } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";

import { rdx_getMaintenanceMessage } from "../../Store/Slices/tenantRegistationSlice";

export default function MaintenanceBanner() {
  const [open, setOpen] = React.useState(true);

  const rdx_getMaintenanceMsg = useSelector(rdx_getMaintenanceMessage);

  return (
    <Box sx={{ width: "100%" }}>
      <Collapse in={open}>
        <Alert
          severity="warning"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2, textAlign: "center" }}
        >
          {rdx_getMaintenanceMsg}
        </Alert>
      </Collapse>
    </Box>
  );
}
